/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type IssueTypeScreenSchemesPage from '@jira/admin-pages__issue-type-screen-schemes-page/src/IssueTypeScreenSchemesPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyIssueTypeScreenSchemesPage: LazyComponent<
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(props: Record<any, any>) => React.JSX.Element
> = lazyForPaint<typeof IssueTypeScreenSchemesPage>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-admin-pages-issue-type-screen-schemes-page", jiraSpaEntry: "async-jira-admin-pages-issue-type-screen-schemes-page" */ '@jira/admin-pages__issue-type-screen-schemes-page/src/IssueTypeScreenSchemesPage.tsx'
		),
	),
);

const AsyncIssueTypeScreenSchemesPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyIssueTypeScreenSchemesPage}
		pageId="jira-admin-pages-issue-type-screen-schemes-page"
		shouldShowSpinner
	/>
);

export default AsyncIssueTypeScreenSchemesPage;
